import { Injectable } from '@angular/core';

import { IInviteContactDialogConfig, IInviteContactDialogResult } from './interfaces';

@Injectable({
  providedIn: 'root'
})
export class InviteContactModalDialogService {
  private readonly selectors = {
    modalDialogOverlay: '[aza-rws-modal-dialog-overlay]',
    modalDialog: '[aza-rws-invite-contact-dialog]',
    cancelButton: '[aza-rws-modal-dialog-first-button]',
    proceedButton: '[aza-rws-modal-dialog-second-button]',
    firstName: '[aza-rws-invite-contact-first-name-input]',
    lastName: '[aza-rws-invite-contact-last-name-input]',
    email: '[aza-rws-invite-contact-email-input]',
  };

  async showPopupDialog(config: IInviteContactDialogConfig): Promise<IInviteContactDialogResult> {
    const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
    const modalDialogEl = document.querySelector(this.selectors.modalDialog);
    this.showElement(modalDialogOverlayEl);
    this.showElement(modalDialogEl);
    const firstNameEl = modalDialogEl.querySelector(this.selectors.firstName) as HTMLInputElement;
    const lastNameEl = modalDialogEl.querySelector(this.selectors.lastName) as HTMLInputElement;
    const emailEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
    firstNameEl.value = config.firstName || '';
    lastNameEl.value = config.lastName || '';
    emailEl.value = config.email || '';
    const promise = new Promise<IInviteContactDialogResult>((resolve, reject) => {
      const cancelBtnEl = modalDialogEl.querySelector(this.selectors.cancelButton) as HTMLDivElement;
      const proceedBtnEl = modalDialogEl.querySelector(this.selectors.proceedButton) as HTMLButtonElement;
      cancelBtnEl.onclick = () => resolve(null);
      proceedBtnEl.onclick = () => {
        resolve({
          firstName: firstNameEl.value,
          lastName: lastNameEl.value,
          email: emailEl.value
        });
      };
    });
    return promise;
  }

  hidePopupDialog(): void {
    const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
    const modalDialogEl = document.querySelector(this.selectors.modalDialog);
    this.hideElement(modalDialogOverlayEl);
    this.hideElement(modalDialogEl);
    const firstNameEl = modalDialogEl.querySelector(this.selectors.firstName) as HTMLInputElement;
    const lastNameEl = modalDialogEl.querySelector(this.selectors.lastName) as HTMLInputElement;
    const emailEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
    firstNameEl.value = '';
    lastNameEl.value = '';
    emailEl.value = '';
  }

  hideElement(el: Element): void {
    el.classList.add('display-none');
  }

  showElement(el: Element): void {
    el.classList.remove('display-none');
  }
}
